module.exports = __webpack_public_path__ + "static/media/complexPic15.8f7a932c.png";